/**
 * @file   src\pages\Home.tsx
 * @brief  Home page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, useState, useNavigate, useParams, useEffect , Button, Modal} from "../utils/thirdpartyComponents";
import CWFooter from "src/components/CWFooter";
import CWSelect from "src/components/CWSelect";
import SelectLocationModal from "src/components/SelectLocationModal";
import Mappinicon from "../assets/images/location-icon.svg";
import Scanimg from "../assets/images/scan-img.svg";
import * as Yup from 'yup';
import { SELECTBAY_SCHEMA } from "../validations/selectBay";
import { pageURLs } from "src/utils/pageUrls";
import { BayApi } from "src/utils/apiUrls";
import { BayItem, Option } from "src/interfaces/bayinterface";
import { getFromLocalStorage , getMobileOperatingSystem, isOpenedAsPWA, setLocalStorage, setActiveLocale} from "src/utils/helper";
import axios from '../config/axiosConfig';
import { LocationApi } from "../utils/apiUrls";
import { useAppDispatch } from 'src/hooks';
import { IHomedata } from '../interfaces/generalInterface';
import { MessageToaster } from "src/utils/toastUtil";
import { CommonMessages } from 'src/messages/validationMessages';
import PaymentfailModal from "../components/PaymentfailModal";
import SmallLoader from '../components/SmallLoader';
import { EquipmentType, ServiceType } from "src/utils/enums";
import { useGeolocated } from "react-geolocated";
import FullLoaderwithlocationfetch from '../components/FullLoaderwithlocationfetch';


const Home = () => {
  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
  useGeolocated({
    positionOptions: {
      enableHighAccuracy: true,
      maximumAge: 0,
      timeout: Infinity,
  },
  watchPosition: false,
  suppressLocationOnMount: false,
  geolocationProvider: navigator.geolocation,
  isOptimisticGeolocationEnabled: true,
  watchLocationPermissionChange: false,
});

  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [locationloading, setlocationLoading] = useState(false);
  const [showSelectLocationModal, setShowSelectLocationModal] = useState(false);
  const [showChangeLocationBtn, setshowChangeLocationBtn] = useState(false);
  const [currentLocation,setCurretLocation] = useState<number>(0)
  const [selectedLocationData, setSelectedLocationData] = useState({ 'locationName': '', 'locationAddress': '' });
  const handleCloseSelectLocationModal = () => setShowSelectLocationModal(false);
  const handleShowSelectLocationModal = () => setShowSelectLocationModal(true);
  const [showWashTypeSelectionModal, setWashTypeSelectionModal] = useState(false);
  const [washSelectionConfirmationMessage, setWashSelectionConfirmationMessage] = useState('');
  const [subscriptionOnlyAvailable, setSubscriptionOnlyAvailable] = useState(true);
  const [showIOSPWAPrompt,setIOSShowPWAPrompt] = useState<any>(undefined);
  const [showAndroidPWAPrompt,setAndroidPWAPrompt] = useState(false);
  const [showReinstallButton,setReinstallButton] = useState(false);
  const [bayList,setBayList] = useState<BayItem[]>([])
  const [selectedBaySubsctiptionType,setSelectedSubsctiptionType] = useState(0)
  const [showBayConfirmationModal, setShowBayConfirmationModal] = useState(false);
  const [pendingBayLabel, setPendingBayLabel] = useState('');

  const navigate = useNavigate();
  const params = useParams();
  const carwashdata = getFromLocalStorage('CARWASH_DATA')
  const carwashcompanydata = getFromLocalStorage('CARWASH_COMPANY_DATA');
  const isOpenedAsAPP = isOpenedAsPWA();
  //If dont have data we need to redirect to login page
  if(!carwashdata) {
      const current_path = window.location.pathname
      const firstPath = current_path.split('/')[1];
      window.location.href = `${process.env.REACT_APP_SITE_URL || ""}${firstPath}?type=snout`
  }
  // payment fail modal
  const [showPaymentfailModal, setShowPaymentfailModal] = useState(false);
  const [relloadLoc,setReloadLoc] = useState<number>(0);
  const handleClosePaymentfailModal = () => setShowPaymentfailModal(false);
  const handleShowPaymentfailModal = () => setShowPaymentfailModal(true);
  

  // Scan Qr click
  const clickScanner = () => {
    navigate("/" + params.carwashname + "/" + pageURLs.qrscanner);
  };

  useEffect(() => {
    localStorage.setItem('selectedBay','') 
    localStorage.removeItem('selectedBay')  // Reset selected bay
    // localStorage.setItem('selectedBayType','')
    localStorage.removeItem('selectedBayType')
  }, []);
  // Initialize select box values
  const [options, setOptions] = useState<Option[]>([]);

  // Initialize states for formdata
  const [formData, setFormData] = useState<IHomedata>({
    bay: '',
  })
  // Initialise states for errors
  const [errors, setErrors] = useState({
    bay: '',
  });

  const bayTypeLabelMap: { [key: number]: EquipmentType } = {
    1: EquipmentType.Tunnel,
    2: EquipmentType.Bay,
    3: EquipmentType.SelfServe,
    4: EquipmentType.DogWash,
    5: EquipmentType.Vacuum,
  };

  // Instantiate MessageToaster
const toaster = new MessageToaster();
const locationReload = () =>{
  setFormData({
      ...formData,
      bay: '',
    });
  setReloadLoc(relloadLoc+1)
}


function getBayLabel(item: any): string {
  if (item.BayName) return item.BayName;
  if (item.BayTypeID && item.BayNumber) {
    return `${bayTypeLabelMap[item.BayTypeID] || "Unknown"} ${item.BayNumber}`;
  }
  return "Unknown";
}
  // To get list of bays in location
  const getBayList = async (resolvedLocationId?: number) => {
    try {
      // Always prefer the latest selected location resolved from API/localStorage.
      const locationId =
        resolvedLocationId ||
        Number(localStorage.getItem('selectedLocation')) ||
        Number(carwashdata?.LocationId);
      const param = {
        locationId
      }
      const { data } = await axios.post(BayApi.GET_BAYS, param)
      if(data?.error === 0){
        const bays_list: BayItem[] = data?.data
        setBayList(bays_list)
        // Transform the array
        const transformedArray: Option[] = bays_list.map(item => ({
          value: item.BayID,
          label:  getBayLabel(item)
        //   (item.BayTypeID && item.BayNumber) ? (item.BayTypeID == 1 ? EquipmentType.Tunnel : EquipmentType.Bay) +' '+item.BayNumber : item.BayName
        }));
        setOptions(transformedArray)
      }

    } catch (error: any) {
      throw new Error(error.response?.data?.message || error.message);
    }
  }

// Function to get SubscriptionType by BayID
const getSubscriptionTypeByBayID = (bayID: number): number | null => {
  const bay = bayList.find((item) => item.BayID === bayID);
  return bay ? bay.SubscriptionType : null;
};

  // Triggers whenever input is entered
  const handleSelectChange = async (selectedOption: any, name: string,selectedOptions:any) => {
    console.log(selectedOptions)
    const value = selectedOption ? selectedOption.value : '';
    localStorage.setItem('selectedBay',value)
    
    const subscriptionType = getSubscriptionTypeByBayID(value);
    localStorage.setItem('selectedBayType', subscriptionType?.toString() ?? "");
    setSelectedSubsctiptionType(subscriptionType ?? 0)//inbay / selfserve
    // To remove validation when user enters input
    const keys = Object.keys(errors);
    if (keys.includes(name)) {
      setErrors({
        ...errors,
        [name]: ""
      })
    }
    await getCurrentLocationCoordinates()
    setFormData({
      ...formData,
      [name]: value,
    });

    

  };
  const handleProceedWithConfirmation = async () => {
    const selectedBay = options.find((option) => String(option.value) === String(formData.bay));
    if (!selectedBay) {
      await washSelectionChecking();
      return;
    }
    setPendingBayLabel(selectedBay.label);
    setShowBayConfirmationModal(true);
  };
  const handleCancelBaySelection = () => {
    setShowBayConfirmationModal(false);
    setPendingBayLabel('');
  };
  const handleConfirmBaySelection = async () => {
    handleCancelBaySelection();
    await washSelectionChecking();
  };

 
  useEffect(() => {
    localStorage.removeItem("subscriptionID")
    const loadSelectedLocationAndBays = async () => {
      const selectedLocationId = await fetchSelectedUserLocation(); // Selected location details
      await getBayList(selectedLocationId); // Bay list for resolved location
    };
    loadSelectedLocationAndBays();
    //  getUserActiveWashdetails()
  }, [dispatch,relloadLoc]);

  const fetchSelectedUserLocation = async () => {
    const { data } = await axios.get(LocationApi.SELECTED_LOCATION_DETAILS);
    if (data?.error === 0) {
      if(data?.data?.locationId === 0 || data?.data?.locationId === null) { //if no location selected we need to redirect to location selection page
        navigate("/"+params.carwashname+"/"+pageURLs.location_switch)
        return 0;
      }
      localStorage.setItem('selectedLocation', data?.data?.locationId)
      setActiveLocale({
        countryCode: data?.data?.countryCode,
        currency: data?.data?.currency,
        locale: data?.data?.locale,
        timezone: data?.data?.timezone,
      });
      const storageData = getFromLocalStorage('CARWASH_DATA');
      if (storageData) {
        storageData.LocationId = data?.data?.locationId;
        setLocalStorage('CARWASH_DATA', JSON.stringify(storageData));
      }
      setCurretLocation(data?.data?.locationId)
      const address = [];
      if(data?.data?.hasDefaultAddress === 1) {
        if(data?.data?.Address1) {
          address.push(data?.data?.Address1)
        }
        // if(data?.data?.Address2) {
        //   address.push(data?.data?.Address2)
        // }
        if(data?.data?.City) {
          address.push(data?.data?.City)
        }
        if(data?.data?.State) {
          address.push(data?.data?.State)
        }
        if(data?.data?.ZipCode) {
          address.push(data?.data?.ZipCode)
        }
      } else {
        if(data?.data?.address1) {
          address.push(data?.data?.address1)
        }
        // if(data?.data?.address2) {
        //   address.push(data?.data?.address2)
        // }
        if(data?.data?.city) {
          address.push(data?.data?.city)
        }
        if(data?.data?.state) {
          address.push(data?.data?.state)
        }
        if(data?.data?.zipCode) {
          address.push(data?.data?.zipCode)
        }
      }
      
      const selectedLocationDetails = {
        "locationName": data?.data?.locationName,
        "locationAddress": address.join(', ')
      }
      setSelectedLocationData(selectedLocationDetails)
      const showBtn = (data?.data?.locationCount > 1) ? true : false
      setshowChangeLocationBtn(showBtn)
      return Number(data?.data?.locationId || 0);
    }
    return 0;
  }
const  hasValidVacuumOrWashTime =(subData: any[]) =>  {
  return subData.some(sub => {
    const hasVacuum = sub.NoOfVacuumWash > 0;
    const hasVacuumRemaining = sub.NoOfVacuumWashRemaining > 0;

    const hasWashTime = sub.WashTime > 0;
    const hasWashTimeRemaining = sub.WashTimeRemaining > 0;

    if (hasVacuum) {
      return hasVacuumRemaining;
    } else {
      return hasWashTime && hasWashTimeRemaining;
    }
  });
}
  //Check subscription status
  const washSelectionChecking = async() => {
    try {

     await SELECTBAY_SCHEMA.validate(formData, { abortEarly: false });

      const geo_location  = getFromLocalStorage('geolocation')
      if(geo_location?.lat && geo_location?.long)
      {
        const timezoneOffset = (new Date()).getTimezoneOffset();
        localStorage.setItem('selectedBay', formData.bay)

        setLoading(true); // Show loader
        const { data } = 
        await axios.get(BayApi.CHECK_WASHES_AVAILABLE, {
          params: {
              lat: geo_location?.lat,
              lng: geo_location?.long,
              bayId : formData.bay ? formData.bay : "",
              offset: timezoneOffset
          }
        });
        setLoading(false); // Hide loader
        if (data.error === 0) {
          console.log("API response:", JSON.stringify(data, null, 2));
          let hostname = window.location.origin
          toaster.toastDismiss()
          if (data.data.subStatus.isWithinDistance === 0 && !(localStorage.getItem('selectedLocation')=='249' && hostname == 'https://staging-web.carwashapp.com') && !(localStorage.getItem('freeSinglewash')=='true' )) { // if user is far from bay checking is disabled for demo location in staging ad per the client requirement
            toaster.toastError(`You seem to be far from the location. Please move closer and initiate the ${data.data.subStatus.bayType ===ServiceType.vacuumWash ? "vacuum":'wash'}.`);
            return false;
          }
          else if (data.data.subStatus.bayType === ServiceType.bayTunnel) // bay/tunnel type
          {
            if (data.data.subStatus?.hasSingleWash === 0 && data.data.subStatus?.hasSubscription === 0 && data.data.subStatus?.hasBulkWash ===0) { //Not purchased both subscription and single wash
              navigate(`/${params.carwashname}/${pageURLs.subscriptionandwashprice}?showSingleWash=true&bayselect=true&fromTab=subscriptions`, { state: { bayId: formData.bay } });
            } else {
              navigate(`/${params.carwashname}/${pageURLs.selectwash}?bayselect=true`);
            }

          }
          else if (data.data.subStatus.bayType != ServiceType.bayTunnel) { // self serve type
            if(data.data.freeVacuumSingleUse==true && data.data.freeVacuumSingleUseId!=0){
              navigate(`/${params.carwashname}/${pageURLs.selfService}?freeVacuum=true`, { state: { UserSubscriptionID: data.data.freeVacuumSingleUseId, bayId: formData.bay } });
            }
            else if ((data.data.subStatus.hasSingleWash === 1 && data.data.subStatus.hasSubscription === 1 ) || (data.data.subData.length > 1)) {
              if(data.data.subStatus.bayType == ServiceType.vacuumWash && hasValidVacuumOrWashTime(data.data.subData)==false)
              {
                toaster.toastError(CommonMessages.no_freevauum_remaining);
                navigate(`/${params.carwashname}/${pageURLs.selfServeSubscriptionandwashprice}?showSingleWash=true&nowashTime=true&bayselect=true&fromTab=subscriptions&bayTypeId=${selectedBaySubsctiptionType}`, { state: { bayId: formData.bay } });
              }
              else{
              navigate(`/${params.carwashname}/${pageURLs.SelfServeSelectwash}?bayselect=true&bayTypeId=${selectedBaySubsctiptionType}`);

              }
            }
            else if (data.data.subData?.length > 0 && data.data.subData[0].HasVacuumWash == 1 && data.data.subStatus.bayType == ServiceType.vacuumWash && data.data.subData[0].SubscriptionType != 1) {
              if (data.data.subData[0].NoOfVacuumWashRemaining > 0) {
                
                navigate(`/${params.carwashname}/${pageURLs.selfService}?scan=true&freeVacuum=true`, { state: { UserSubscriptionID: data.data.subData[0].UserSubscriptionID, bayId: formData.bay } });

              }
              else {
                toaster.toastError(CommonMessages.no_freevauum_remaining);
                navigate(`/${params.carwashname}/${pageURLs.selfServeSubscriptionandwashprice}?showSingleWash=true&nowashTime=true&bayselect=true&fromTab=subscriptions&bayTypeId=${selectedBaySubsctiptionType}`, { state: { bayId: formData.bay } });

              }
            }
             else if (data.data.subData?.length > 0 && data.data.subData[0].HasSelfService == 1 && data.data.subStatus.bayType == ServiceType.selfServe && data.data.subData[0].SubscriptionType != 1) {
              if (data.data.subData[0].NumberOfSelfServicesRemaining > 0) {
                
                navigate(`/${params.carwashname}/${pageURLs.selfService}?scan=true&freeSelfServe=true`, { state: { UserSubscriptionID: data.data.subData[0].UserSubscriptionID, bayId: formData.bay } });

              }
              else {
                toaster.toastError(CommonMessages.no_freevauum_remaining);
                navigate(`/${params.carwashname}/${pageURLs.selfServeSubscriptionandwashprice}?showSingleWash=true&nowashTime=true&bayselect=true&fromTab=subscriptions&bayTypeId=${selectedBaySubsctiptionType}`, { state: { bayId: formData.bay } });

              }
            }
            else if ((data.data.subStatus.hasSingleWash === 1 || data.data.subStatus.hasSubscription === 1 ||  data.data.subStatus.hasBulkWash === 1 ) && data.data.subData.length > 0 && data.data.subData[0].WashTimeRemaining > 0) {
              navigate(`/${params.carwashname}/${pageURLs.selfService}?bayTypeId=${selectedBaySubsctiptionType}`, { state: { UserSubscriptionID: data.data.subData[0].UserSubscriptionID, bayId: formData.bay } });
            }
            
            else {
                console.log("[DEBUG] Final else triggered");

              // console.log(data.data.subData?.length , data.data.subData[0].HasVacuumWash , data.data.subStatus.bayType)
              if(data?.data?.subData[0]?.WashTimeRemaining <= 0)
              {
                 toaster.toastError(CommonMessages.no_wash_time_remaining);
              }
              navigate(`/${params.carwashname}/${pageURLs.selfServeSubscriptionandwashprice}?showSingleWash=true&nowashTime=true&bayselect=true&fromTab=subscriptions&bayTypeId=${selectedBaySubsctiptionType}`, { state: { bayId: formData.bay } });

            }

          }
          
        } else {
          toaster.toastError(data.message);
        } 
        
      } else{
        localStorage.removeItem('locationPermissionDenied');
        toaster.toastError(CommonMessages.no_loc_permission);
      }
      
    }  catch (error) {
      //If validation fails on submit, then errors are shown
      if (error instanceof Yup.ValidationError) {
        const newErrors: any = {};
        error.inner.forEach((err) => {
          newErrors[err.path as keyof typeof formData] = err.message;
        });
        setErrors(newErrors);
      }
    }
  }

  useEffect(() => {
    if(isGeolocationAvailable && isGeolocationEnabled && coords!== undefined) {
      localStorage.setItem('locationPermissionGranted', 'true'); // Store the granted state
      localStorage.setItem('geolocation',JSON.stringify({ lat: coords?.latitude, long: coords?.longitude }))
      
    } else {
      localStorage.removeItem('locationPermissionGranted');
      localStorage.removeItem('geolocation');
    }
   // setTimeout(() => getCurrentLocationCoordinates(), 1000);
   if(isGeolocationAvailable && isGeolocationEnabled && coords!== undefined && localStorage.getItem('locationPermissionGranted') !== 'true') {
    setlocationLoading(true);
    setTimeout(() => {
      setlocationLoading(false);
    }, 5000);
  }
    
  }, [coords, isGeolocationAvailable, isGeolocationEnabled]);


  const getCurrentLocationCoordinates = async() => {
    
    if (navigator.geolocation) {
      const status = await navigator.permissions.query({ name: 'geolocation' });
        if(status.state === 'granted') {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                      const { latitude, longitude } = position.coords;
                      localStorage.setItem('geolocation',JSON.stringify({ lat: latitude, long: longitude }))
                    },
                    (err) => {
                        console.log(err, err.PERMISSION_DENIED)
                    }
                );
            }
        }
    }
};

//show installation prompt
const showInstallPrompt = async() => {
  const deviceType = getMobileOperatingSystem();
  localStorage.removeItem('closedIosPrompt') ;
  localStorage.removeItem('installPromptCancelled') 
  localStorage.removeItem('iosPwaPrompt')
  if(deviceType === 2) {
    setIOSShowPWAPrompt(true)
  } else {
    setAndroidPWAPrompt(true)
    window.location.reload()
  }
  
}
//IOS prompt closing action
const closedIosAction = async() => {
  localStorage.setItem('closedIosPrompt',"true");
  setIOSShowPWAPrompt(false)
  setReinstallButton(true)
}

return (
    <div className="common-content-wrap home-content-wrap pb-80">
      <div className="inner-content-wrap">
        <div className="common-header multi-group-header">
          <div className="pe-4 ps-4 pt-0 pb-0 h-100">
            <div className="common-header-inner">
             
              <img src={Mappinicon} alt="Car Wash App" />
              <div className="info">
              {selectedLocationData?.locationName ? <h4>{selectedLocationData?.locationName}</h4> : <h4>{carwashcompanydata?.companyName}</h4>}
                {/* {selectedLocationData?.locationName ? <p>{selectedLocationData.locationName}</p> : ''} */}
                {selectedLocationData.locationAddress ? <p>{selectedLocationData?.locationAddress}</p> : ''}
              </div>
              {showChangeLocationBtn && <Button variant="primary" className="primary-btn btn-sm" onClick={() => handleShowSelectLocationModal()}>Change</Button>}
            </div>
          </div>
        </div>

        <div className="scanner-block d-flex justify-content-center align-items-center">
          <div className="qr-scanner d-flex justify-content-center align-items-center" onClick={clickScanner}>
            <img src={Scanimg} alt="Car Wash App" />
            <h3>Scan QR</h3>
          </div>
        </div>
          <div className="main-content-wrap pe-0 ps-0 pt-0">
          <div className="search-wrap">
         
            <h5 className="text-center">or</h5>
          
              <CWSelect
                id="bay"
                name="bay"
                options={(isGeolocationAvailable && isGeolocationEnabled && coords!== undefined && coords?.latitude && coords?.longitude) ? options : []}
                label="Bay Type/Number"
                errorMessage={errors.bay && errors.bay}
                dropdownGap={0}
                dropdownPosition="auto"
                values={formData.bay ? options.filter(option => String(option.value) == String(formData.bay)) : []}
                onChange={(selectedOptions) => handleSelectChange(selectedOptions[0], 'bay',selectedOptions)}
                placeholder="Choose one"
                multi={false}
                searchable= {false}
                disabled={(isGeolocationAvailable && isGeolocationEnabled && coords!== undefined) ?  false : true}
              />
              {loading && <SmallLoader />}
              <Button variant="primary" type="submit" className="primary-btn btn-main"  onClick={handleProceedWithConfirmation} disabled={(isGeolocationAvailable && isGeolocationEnabled && coords!== undefined) ? false : true}>Proceed </Button>
              {(isGeolocationAvailable && isGeolocationEnabled && coords === undefined) ? <FullLoaderwithlocationfetch /> : ''}
             {(!isGeolocationAvailable || !isGeolocationEnabled) ? <div className="text-center purchase-msg error-msg">Your current location is not available. Please Scan the QR code to proceed. </div> : ''}
          </div>
        </div> 
      </div >
      {((localStorage.getItem('closedIosPrompt') === 'true' || localStorage.getItem('installPromptCancelled') === 'true' || showReinstallButton || localStorage.getItem('iosPwaPrompt')) && isOpenedAsAPP === false) ? <div className="allow-sec text-center"><Button  variant="primary" className='primary-btn btn-main' onClick={()=>{showInstallPrompt()}}>Install app</Button></div> : ''}
      <CWFooter activeLink="Home" showLocationPermissionPrompt={(localStorage.getItem('locationPermissionGranted') !== 'true') ? true : false} showInstallationBtn={true} showIOSPWAPrompt={showIOSPWAPrompt} showAndroidPWAPrompt = {showAndroidPWAPrompt} closedIosAction = {closedIosAction}/>

      {/* <Modal
        show={showWashTypeSelectionModal}
        onHide={HideWashSelectionModal}
        centered
        className='notification-modal'
      >
        <Modal.Body className='text-center'>
          <h6>{washSelectionConfirmationMessage}</h6>
            
        </Modal.Body>
        <Modal.Footer className='d-flex flex-column'>
          {subscriptionOnlyAvailable === true ?
          <>
            <Button variant="primary" className='primary-btn btn-main m-0 w-100'  onClick={(e) => { handleSubmit(e, 2) }}>Use Subscription</Button>
            <Button variant="primary" className='primary-btn btn-main m-0 w-100'  onClick={purchaseSingleWash}>Buy Single Wash</Button>
          </> : 
          <>
            <Button variant="primary" className='primary-btn btn-main m-0 w-100'  onClick={(e) => { handleSubmit(e, 2) }}>Subscription</Button>
            <Button variant="primary" className='primary-btn btn-main m-0 w-100'  onClick={(e) => { handleSubmit(e, 1) }}>Single Wash</Button>
          </>
          }
        </Modal.Footer>
      </Modal> */}

      <SelectLocationModal
        show={showSelectLocationModal}
        onHide={handleCloseSelectLocationModal}
        locationReload = {locationReload}
        selectedLocation = {currentLocation}
      />
      <PaymentfailModal
      show={showPaymentfailModal}
      onHide={handleClosePaymentfailModal}
      />
      <Modal
        show={showBayConfirmationModal}
        onHide={handleCancelBaySelection}
        centered
        className='notification-modal'
      >
        <Modal.Body className='text-center'>
          <h6>{`You selected ${pendingBayLabel}. Make sure this is correct before continuing. Do you want to proceed?`}</h6>
        </Modal.Body>
        <Modal.Footer className='d-grid'>
          <Button variant="light" className="m-0" onClick={handleCancelBaySelection}>Cancel</Button>
          <Button variant="primary" className='primary-btn btn-main m-0' onClick={handleConfirmBaySelection}>Confirm</Button>
        </Modal.Footer>
      </Modal>
    </div >
  )

};

export default Home;
